import { match } from "ts-pattern";
import { isLocale, separateLocale } from "../..";

export function getConstants() {
	return {
		splashUrl: "https://www.tosize.com",
		assets: {
			host: "https://static.tosize.com",
			generalFolder: "General",
		},
		customer: {
			business: {
				discount: 5,
			},
		},
		customerService: {
			phone: "085 888 29 55",
			businessPhone: "085 401 77 97",
			phoneHtml: "+31858882955",
			businessPhoneHtml: "+31854017797",
		},
		deliveryTime: {
			furniture: {
				min: 2,
				max: 4,
			},
		},
		products: {
			sheetFurniture: {
				name: "TOSIZE Furniture",
			},
			edgeband: {
				enabled: true,
			},
		},
	};
}

export function getLocaleConstants(current: string) {
	return {
		customerServicePhone: isLocale({ current, pattern: "language", supported: ["nl", "en"] }),
		showroom: isLocale({ current, pattern: "country", supported: ["nl"] }),
		stylists: isLocale({ current, pattern: "country", supported: ["nl"] }),
		takeaway: isLocale({ current, pattern: "country", supported: ["nl"] }),
		workAtSite: isLocale({ current, pattern: "language-country", supported: ["nl-nl"] }),
		postcode: !isLocale({ current, pattern: "country", supported: ["nl", "be", "ie"] }),
		impressum: isLocale({ current, pattern: "country", supported: ["de"] }),
		businessAccount: isLocale({
			current,
			pattern: "country",
			supported: ["fr", "be", "at", "de", "nl"],
		}),
		kiyoh: {
			totalScore: isLocale({ current, pattern: "country", supported: ["de"] }) ? 5 : 10,
		},
		trustpilot: isLocale({ current, pattern: "country", supported: ["de"] }),
		contact: false,
		furniture: {
			assemblyVideoId: match(separateLocale(current).language)
				.with("de", () => "1004490037")
				.with("fr", () => "1004492293")
				.with("nl", () => "1004493009")
				.with("da", () => "1004496348")
				.with("cs", () => "1004496285")
				.with("fi", () => "1004496415")
				.with("it", () => "1004494531")
				.with("es", () => "1004494475")
				.with("pl", () => "1004496455")
				.with("sv", () => "1004496551")
				.with("pt", () => "1004496493")
				.with("en", () => "1003649574")
				.otherwise(() => null),
		},
	};
}
